// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {hasAccess} from '../../../shared/services/security';
import {hasPermission} from '../../../shared/services/privacy';

const NonTrackedPinInfoBox = (props, context) =>
    <div className='help-text'>
        <FormattedMessage id='NON_TRACKED_PINS_HELP_TEXT'/>
        {hasAccess(context.security, 'PRT', 'PRT_REGISTER_PRODUCT') && hasPermission(context.user.privacy, 'registrationNotAllowed') ?
            <Link to={`/products/register-product?pin=${props.pin}`}>
                <FormattedMessage id='REGISTER_A_PRODUCT_BY_PIN'/>
            </Link> :
            <FormattedMessage id='REGISTER_A_PRODUCT_TO_ADD'/>
        }
    </div>;

NonTrackedPinInfoBox.displayName = 'NonTrackedPinInfoBox';
NonTrackedPinInfoBox.propTypes = {
    pin: PropTypes.string.isRequired
};
NonTrackedPinInfoBox.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default NonTrackedPinInfoBox;



// WEBPACK FOOTER //
// ./src/product/search/components/non-tracked-pin-info-box.js